module.exports = __webpack_public_path__ + "static/media/paul-writer-logo.438ce7ab.png";